import formatter from "ips/ac/model/formatter";
import Util from "ips/ac/util/Util";
import Color from "ips/ac/application/definition/Color";

export default {
  ...formatter,

  getNoteText(sDescription: string | null | undefined): string {
    if (!sDescription || sDescription.trim() === "") {
      return Util.getText("@InternalOrderStatus_Dialog_Table_Content_NoteIsNotPresent");
    }
    return Util.getText("@InternalOrderStatus_Dialog_Table_Content_NoteIsPresent");
  },

  getNoteIconColor(isDarkMode: boolean) {
    return Color.get(Color.BLUE_TEXT);
  },

  isNoteIconVisible(sDescription: string | null | undefined): boolean {
    return !!sDescription && sDescription.trim() !== "";
  },

  getTextColor(isDarkMode: boolean) {
    return Color.get(Color.TEXT_COLOR);
  },
};